export default {
  state: {
    oldMarketList: [
      { id: 'da-DK', name: 'Denmark' },
      { id: 'de-AT', name: 'Austria' },
      { id: 'de-CH', name: 'Switzerland' },
      { id: 'de-DE', name: 'Germany' },
      { id: 'en-CA', name: 'Canada' },
      { id: 'en-GB', name: 'United Kingdom' },
      { id: 'en-NL', name: 'Netherlands' },
      { id: 'en-US', name: 'United States' },
      { id: 'es-ES', name: 'Spain' },
      { id: 'es-MX', name: 'Mexico' },
      { id: 'et-EE', name: 'Estonia' },
      { id: 'fi-FI', name: 'Finland' },
      { id: 'it-IT', name: 'Italy' },
      { id: 'lt-LT', name: 'Lithuania' },
      { id: 'lv-LV', name: 'Latvia' },
      { id: 'no-NO', name: 'Norway' },
      { id: 'ro-RO', name: 'Romania' },
      { id: 'sv-SE', name: 'Sweden' },
    ],
  },
  getters: {
    oldMarketList(state) {
      return state.oldMarketList
    },
  },
}
